import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';

export const useAuth = (requiredPermissions = []) => {
  const { user, isAuthenticated, loading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user has required permissions
  const hasPermission = useMemo(() => {
    if (!user?.permissions || requiredPermissions.length === 0) return true;
    
    return requiredPermissions.some(permission => {
      // Check for exact permission or wildcard permission (e.g., 'module.*')
      return user.permissions.includes(permission) || 
             user.permissions.includes(`${permission.split('.')[0]}.*`);
    });
  }, [user, requiredPermissions]);

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/login', { state: { from: location }, replace: true });
    }
  }, [isAuthenticated, loading, navigate, location]);

  // Redirect to unauthorized if missing required permissions
  useEffect(() => {
    if (!loading && isAuthenticated && requiredPermissions.length > 0 && !hasPermission) {
      navigate('/unauthorized', { state: { from: location }, replace: true });
    }
  }, [isAuthenticated, loading, hasPermission, requiredPermissions, navigate, location]);

  return {
    user,
    isAuthenticated,
    loading,
    hasPermission,
    permissions: user?.permissions || []
  };
};

export default useAuth;